




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BusinessHoursSelection from '../businessHoursSelection/BusinessHoursSelection.vue';
import { BusinessHoursOptions } from '../businessHoursSelection';
import { BusinessHoursViewModel } from '../../models';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';

enum ScheduleType {
	AnyTime,
	InHours,
	OutOfHours,
	CustomTimes
}

@Component({
	components: {
		BusinessHoursSelection
	}
})
export default class TriggerScheduler extends Vue {
	@Prop() public condition: ConditionViewModel;
	@Prop() public openingTimes: BusinessHoursViewModel[];

	public invalid: boolean = false;
	public selectedSchedule = ScheduleType.AnyTime;
	public ScheduleType = ScheduleType;

	public customTimes: BusinessHoursViewModel[] = [];

	@Watch('openingTimes', { immediate: true })
	public onOpeningTimesChanged(openingTimes: BusinessHoursViewModel[], previous: BusinessHoursViewModel[]) {
		this.customTimes = openingTimes;
	}

	@Watch('condition', { immediate: true })
	public onConditionChanged(condition: ConditionViewModel, previous: ConditionViewModel) {
		this.selectedSchedule = this.getSelectedSchedule();
	}

	get showCustomTimePicker(): boolean {
		return this.selectedSchedule === ScheduleType.CustomTimes;
	}

	public getSelectedSchedule() {
		if (this.hasNoSchedule()) {
			return ScheduleType.AnyTime;
		}

		if (this.isInHours()) {
			if (this.openingTimes.length) {
				return ScheduleType.CustomTimes;
			}
			return ScheduleType.InHours;
		}

		if (!this.isInHours()) {
			return ScheduleType.OutOfHours;
		}

		return ScheduleType.AnyTime;
	}

	public hasNoSchedule() {
		return !this.condition || !this.hasAttribute() || !this.isScheduleCondition();
	}

	public isInHours() {
		return this.condition.attribute === 'bot.openingTimes' &&
			this.condition.operation === 'contains' &&
			this.condition.result;
	}

	public switchedScheduleType() {
		this.invalid = false;
		this.scheduleChanged();
	}

	public scheduleChanged() {
		if (this.selectedSchedule === ScheduleType.CustomTimes) {
			if (!this.customTimes.length) {
				this.customTimes = [BusinessHoursOptions.getDefaultModel()];
			}
		} else {
			this.customTimes = [];
		}
		this.$emit('updated', this.createScheduleCondition(this.selectedSchedule), {customTimes: this.customTimes});
	}

	public setInvalid(invalid: boolean) {
		this.invalid = invalid;
	}

	private createScheduleCondition(type: ScheduleType) {
		switch (type) {
			case ScheduleType.InHours:
			case ScheduleType.CustomTimes:
				return this.createCondition(true);
			case ScheduleType.OutOfHours:
				return this.createCondition(false);
		}
	}

	private isScheduleCondition() {
		if (this.condition.attribute) {
			return this.condition.attribute === 'bot.openingTimes';
		}
		return false;
	}

	private hasAttribute() {
		return this.condition.attribute && this.condition.attribute.length > 0;
	}

	private createCondition(inHours: boolean) {
		return {
			attribute: 'bot.openingTimes',
			operation: 'contains',
			type: 'datetime',
			value: 'utcNow',
			result: inHours,
			invalid: this.invalid
		} as ConditionViewModel;
	}
}
